import { render, staticRenderFns } from "./WhsPL_List.vue?vue&type=template&id=6fc76a16"
import script from "./WhsPL_List.vue?vue&type=script&lang=js"
export * from "./WhsPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports